module.exports = __webpack_public_path__ + "img/document-colored-icon.f4bd15f6.svg";